import { useEffect } from 'react'
import { useLoaderData, Link } from 'react-router'
import { createClient } from '@/api-client'
import { Subscriptions } from '@/api-client/Subscriptions'
import logo from './images/logo.svg'
import instagram from './images/instagram.svg'

export const loader = () => {
  return fetchSubscriptions()
}

function fetchSubscriptions() {
  return createClient(Subscriptions).getSubscriptions({ category: 'rose' })
}

export const SubscriptionRoseSubscribed: React.FC = () => {
  const {
    data: { data: subscriptions },
  } = useLoaderData<typeof loader>()

  useEffect(() => {
    const subscription = subscriptions[0]

    if (subscription && subscription.attributes.status === 'active') {
      if (window.fbq) {
        window.fbq(
          'track',
          'Subscribe',
          {
            value: 3400,
            currency: 'JPY',
          },
          {
            eventID: `subscription_subscribed_${subscription.id}`,
          },
        )
      }

      if (window.dataLayer) {
        const key = `subscribed-tracked-${subscription.id}`

        if (!window.localStorage.getItem(key)) {
          window.localStorage.setItem(key, '1')
          window.dataLayer.push({ event: 'subscribed' })
        }
      }
    }
  }, [])

  return (
    <div className="min-h-screen bg-bg font-sans flex flex-col">
      <main className="flex-1 max-w-2xl mx-auto w-full flex flex-col">
        <div className="px-5 pt-10 pb-8 border-b border-gray/40 flex flex-col gap-2">
          <Link to="/">
            <img src={logo} alt="FLOWER" className="h-6 mb-6" />
          </Link>
          <h1 className="text-[22px] font-bold text-black leading-relaxed">
            定期便のお申し込みが
            <br />
            完了しました
          </h1>
          <p className="text-[14px] text-[#828282] leading-relaxed">季節のバラをお楽しみに😍</p>
        </div>

        <div className="px-5 pt-7 pb-8 border-b border-gray/40 flex flex-col gap-3">
          <p className="text-[13px] text-[#828282] leading-relaxed tracking-wide">
            お届けのスキップや住所・カードの変更は
            <br />
            マイページからいつでもできます
          </p>
          <Link
            to="/subscription/rose/mypage"
            className="block w-full py-3.5 bg-black text-white text-[14px] font-bold rounded-full text-center tracking-wide"
          >
            マイページを見る
          </Link>
        </div>

        <div className="px-5 pt-7 pb-10 flex flex-col gap-4">
          <p className="text-[13px] text-[#828282] leading-relaxed tracking-wide">
            アプリのお花屋さん「FLOWER（フラワー）」の最新情報は公式Instagramで。平日ほぼ毎日ライブ配信中⚡️お花好きさんはぜひフォローをお願いします！
          </p>
          <div>
            <a
              href="https://www.instagram.com/flowr_is/"
              target="_blank"
              className="inline-flex items-center gap-1.5 px-4 py-2 bg-black text-white text-[13px] font-bold rounded-full"
            >
              <img src={instagram} alt="Instagram" className="w-4 h-4" />
              公式Instagramへ
            </a>
          </div>
        </div>
      </main>
    </div>
  )
}
